import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            name: "Setup Form",
            key: "form",
            route: "/form/setup",
            privacy: "private",
        },
    ];
};

export default settingMenus;